module.exports = __webpack_public_path__ + "img/model_20_ug.d45fe6a4.jpg";